import { MenuItemsCA } from 'routes/menu-items';
import { ApplicableAction, ContextActions } from 'utils/constants';
import { ContextAction } from 'models/contextActions';

const {
  CA_EAI_ACCESS_USER_PAGE,
  CA_EAI_ACCESS_PARTY_PAGE,
  CA_EAI_ACCESS_BALANCING_GROUP_PAGE,
  CA_EAI_ACCESS_DELIVERY_POINT_PAGE,
  CA_EAI_ACCESS_DEVICE_PAGE,
  CA_EAI_ACCESS_DELIVERY_CONTRACT_PAGE
} = ContextActions.EAI;

const {
  CA_DISP_ACCESS_ONLINE_DISPATCHING_PAGE,
  CA_DISP_ACCESS_PRODUCTION_PLAN_PAGE,
  CA_DISP_ACCESS_CONSUMPTION_PLAN_PAGE,
  CA_DISP_ACCESS_OPERATION_CALENDAR_PAGE,
  CA_DISP_ACCESS_SYSTEM_IMBALANCE_EVALUATION_PAGE,
  CA_DISP_ACCESS_DELIVERY_POINT_PRODUCTION_PLAN_EVALUATION_PAGE,
  CA_DISP_ACCESS_DEVICE_PRODUCTION_PLAN_EVALUATION_PAGE,
  CA_DISP_ACCESS_BALANCING_GROUP_EVALUATION_PAGE,
  CA_DISP_ACCESS_REPORTING_PAGE,
  CA_DISP_ACCESS_EVENT_OVERVIEW_PAGE,
  CA_DISP_ACCESS_H_PLUS_X_SI_PAGE,
  CA_DISP_ACCESS_RESERVED_CAPACITY_PAGE
} = ContextActions.DISPATCHER;

const { CA_DISP_ACCESS_ECONOMIC_BENEFIT_EVALUATION_PAGE } =
  ContextActions.REPORTING;

// ==============================|| UTILS ||============================== //

export const getMenuItemsCa = (
  dispatcherCA: ContextAction[],
  dispatcherCAForCurrentBalancingGroup: ContextAction[],
  eaiCA: ContextAction[]
): MenuItemsCA => {
  const canAccessUserPage = eaiCA
    ? eaiCA.find((ca) => ca && ca.code === CA_EAI_ACCESS_USER_PAGE)
        ?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessPartyPage = eaiCA
    ? eaiCA.find((ca) => ca && ca.code === CA_EAI_ACCESS_PARTY_PAGE)
        ?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessBalancingGroupPage = eaiCA
    ? eaiCA.find((ca) => ca && ca.code === CA_EAI_ACCESS_BALANCING_GROUP_PAGE)
        ?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessDeliveryPointPage = eaiCA
    ? eaiCA.find((ca) => ca && ca.code === CA_EAI_ACCESS_DELIVERY_POINT_PAGE)
        ?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessDevicePage = eaiCA
    ? eaiCA.find((ca) => ca && ca.code === CA_EAI_ACCESS_DEVICE_PAGE)
        ?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessDeliveryContractPage = eaiCA
    ? eaiCA.find((ca) => ca && ca.code === CA_EAI_ACCESS_DELIVERY_CONTRACT_PAGE)
        ?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessOnlineDispatchingPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) => ca && ca.code === CA_DISP_ACCESS_ONLINE_DISPATCHING_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessProductionPlanPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) => ca && ca.code === CA_DISP_ACCESS_PRODUCTION_PLAN_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessConsumptionPlanPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) => ca && ca.code === CA_DISP_ACCESS_CONSUMPTION_PLAN_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessOperationCalendarPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) => ca && ca.code === CA_DISP_ACCESS_OPERATION_CALENDAR_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessHxDashboardPage = dispatcherCAForCurrentBalancingGroup
    ? dispatcherCAForCurrentBalancingGroup.find(
        (ca) => ca && ca.code === CA_DISP_ACCESS_H_PLUS_X_SI_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessRkDashboardPage = dispatcherCAForCurrentBalancingGroup
    ? dispatcherCA.find(
        (ca) => ca && ca.code === CA_DISP_ACCESS_RESERVED_CAPACITY_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessSystemImbalanceReportsPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) =>
          ca && ca.code === CA_DISP_ACCESS_SYSTEM_IMBALANCE_EVALUATION_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessBalancingGroupReportsPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) => ca && ca.code === CA_DISP_ACCESS_BALANCING_GROUP_EVALUATION_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessDeliveryPointProductionPlanReportsPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) =>
          ca &&
          ca.code ===
            CA_DISP_ACCESS_DELIVERY_POINT_PRODUCTION_PLAN_EVALUATION_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessDeviceProductionPlanReportsPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) =>
          ca &&
          ca.code === CA_DISP_ACCESS_DEVICE_PRODUCTION_PLAN_EVALUATION_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessReportingPage = dispatcherCA
    ? dispatcherCA.find((ca) => ca && ca.code === CA_DISP_ACCESS_REPORTING_PAGE)
        ?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessEventOverviewPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) => ca && ca.code === CA_DISP_ACCESS_EVENT_OVERVIEW_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  const canAccessEconomicBenefitEvaluationPage = dispatcherCA
    ? dispatcherCA.find(
        (ca) =>
          ca && ca.code === CA_DISP_ACCESS_ECONOMIC_BENEFIT_EVALUATION_PAGE
      )?.applicability === ApplicableAction.ENABLED
    : false;

  return {
    canAccessUserPage,
    canAccessPartyPage,
    canAccessBalancingGroupPage,
    canAccessDeliveryPointPage,
    canAccessDevicePage,
    canAccessDeliveryContractPage,
    canAccessOnlineDispatchingPage,
    canAccessConsumptionPlanPage,
    canAccessProductionPlanPage,
    canAccessOperationCalendarPage,
    canAccessHxDashboardPage,
    canAccessRkDashboardPage,
    canAccessSystemImbalanceReportsPage,
    canAccessBalancingGroupReportsPage,
    canAccessDeliveryPointProductionPlanReportsPage,
    canAccessDeviceProductionPlanReportsPage,
    canAccessReportingPage,
    canAccessEventOverviewPage,
    canAccessEconomicBenefitEvaluationPage
  };
};

export const checkAllForbidden = (menuItemsCA: MenuItemsCA) => {
  return Object.values(menuItemsCA).every((value) => !value);
};
